import React, { useCallback, useState } from 'react';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import TextField from '@mui/material/TextField';
import { format, parse } from "date-fns";
import { jsDateFormatter } from './../../../utils/jsDateFormatter'

const CommonDateField = ({ onChange, value,readOnlyAmend, InputProps, onOpen, onClose, open, renderInput, minDate, maxDate, placeholder, defaultCalendarMonth }) => {
    const contractStatus = sessionStorage.getItem('Selected Contract Status');
    const dateFnsFormat = "MM/dd/yyyy";
    const formatDate = useCallback((date) => format(date, dateFnsFormat), []);
    const parseDate = useCallback((date) => parse(date, dateFnsFormat), []);

    // Ensure value is null if empty so placeholder is shown
    const safeValue = value === '' ? null : value;

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DesktopDatePicker
                open={open}
                onOpen={onOpen}
                onClose={onClose}
                value={safeValue}
                onChange={onChange}
                InputProps={InputProps}
                minDate={minDate}
                maxDate={maxDate}
                defaultCalendarMonth={defaultCalendarMonth}
                renderInput={params => (
                    <TextField {...params} placeholder={placeholder} size="small" inputProps={{...params.inputProps, readOnly: true}} fullWidth />
                )}
                reduceAnimations={true}
                readOnly={(contractStatus === "ACTIVE" || readOnlyAmend ) ? true : false}
            />
        </LocalizationProvider>
    )
}

export default CommonDateField;